import styled from 'styled-components';

export const DataProviderRequestContainer = styled.div`
  min-height: calc(100vh - 60px);
  background: #f7f7f7;

  .wrapBox {
    padding: 0 35px 30px 35px;
    background: #fff;
  }
`;
